import store from '@/store'

// The settings panel derives each field's label by stripping the __<type>__
// suffix off the configuration key; the change history reuses those exact
// translation ids, so a step is named after the field the user edited.
//
// Only ids that actually resolve to a translation may become a label - a raw
// key like "wb_buttons" must never surface in the UI. Steps whose keys are all
// untranslated get null and the history falls back to its generic label.
export default function labelForConfigurationChange (keys: Array<string>): string | null {
  const translations = (store.state as Record<string, any>).setup.translations as Record<string, string> | null

  if (!translations) {
    return null
  }

  const labels = keys
    .map((key) => {
      const match = key.match(/^(.+?)__[a-z_]+__$/)
      return match ? match[1] : null
    })
    .filter((id): id is string => id !== null && Boolean(translations[id]))
    .map((id) => translations[id])

  if (labels.length === 0) {
    return null
  }

  return keys.length > 1 ? `${labels[0]} +${keys.length - 1}` : labels[0]
}
